export enum ErrorCodes {
  'General/UnknownError' = 'ct-library.errors.general.unknown-error',
  'General/Success' = 'ct-library.errors.general.success',
  'General/NoChanges' = 'ct-library.errors.general.no-changes',
  'General/NotFound' = 'ct-library.errors.general.not-found',
  'General/InvalidURL' = 'ct-library.errors.general.invalid-url',
  'General/DeleteAccount/AlreadyMarkedForDeletion' = 'ct-library.errors.general.delete-account.already-marked-for-deletion',
  'General/Expired' = 'ct-library.errors.general.expired',
  'General/NameNotUnique' = 'ct-library.errors.general.name-not-unique',
  'General/NameConflict' = 'ct-library.errors.general.name-conflict',
  'General/InvalidEMailDomain' = 'ct-library.errors.general.invalid-email-domain',
  'General/Forbidden' = 'ct-library.errors.general.forbidden',
  'General/ConfirmationFailed' = 'ct-library.errors.general.confirmation-failed',

  'Auth/Login/WrongCredentials' = 'ct-library.errors.auth.login.wrong-credentials',
  'Auth/Login/AlreadyLoggedIn' = 'ct-library.errors.auth.login.already-logged-in',
  'Auth/Login/AccountBlocked' = 'ct-library.errors.auth.login.account-blocked',
  'Auth/Login/UnverifiedEMailAddress' = 'ct-library.errors.auth.login.unverified-email-address',
  'Auth/TooManyAttempts' = 'ct-library.errors.auth.login.too-many-attempts',
  'Auth/Unauthenticated' = 'ct-library.errors.auth.unauthenticated',
  'Auth/Unauthorized' = 'ct-library.errors.auth.unauthorized',
  'Auth/InvalidLink' = 'ct-library.errors.auth.invalid-link',
  'Auth/InvalidLinkAlreadyVerified' = 'company-tool.errors.auth.invalid-link-already-verified',
  'Auth/InsecurePassword' = 'ct-library.errors.auth.insecure-password',
  'Auth/EMailInUse' = 'ct-library.errors.auth.email-in-use',
  'Auth/YouAreARobot' = 'ct-library.errors.auth.you-are-a-robot',
  'Auth/CAPTCHATimeout' = 'ct-library.errors.auth.captcha-timeout',
  'Auth/Login/Timeout' = 'ct-library.errors.auth.login-timeout',

  'Backend/RenewInvitation/NoLink' = 'ct-library.errors.backend.renew-invitation.no-link',

  'Applicant/AddMissingData/StillMissingData' = 'ct-library.errors.applicant.add-missing-data.still-missing-data',
  'Applicant/AddMissingData/ApplicationComplete' = 'ct-library.errors.applicant.add-missing-data.application-complete',
  'Applicant/AddMissingData/ApplicationAlreadyComplete' = 'ct-library.errors.applicant.add-missing-data.application-complete',
  'Applicant/Apply/CompanyNotFound' = 'ct-library.errors.applicant.apply.company-not-found',
  'Applicant/Apply/JobNotFound' = 'ct-library.errors.applicant.apply.job-not-found',
  'Applicant/Apply/FacilityNotFound' = 'ct-library.errors.applicant.apply.facility-not-found',
  'Applicant/Apply/QuestionNotFound' = 'ct-library.errors.applicant.apply.question-not-found',
  'Applicant/Apply/AlreadyApplied' = 'ct-library.errors.applicant.apply.already-applied',

  'Company/URLInUse' = 'ct-library.errors.company.url-in-use',
  'Company/NamespaceInUse' = 'ct-library.errors.company.namespace-in-use',
  'Company/AbbreviationInUse' = 'ct-library.errors.company.abbreviation-in-use',
  'Company/NameConflict' = 'ct-library.errors.company.name-confilct',
  'Company/EMailInUseByDeletedUser' = 'ct-library.errors.company.email-in-use-by-deleted-user',
  'Company/NoAdminLeft' = 'ct-library.errors.company.no-admin-left',
  'Company/HeadquartersNotDeletable' = 'ct-library.errors.company.headquarters-not-deletable',
  'Company/DeleteProcessStep/ApplicationsInThisStep' = 'ct-library.errors.company.delete-process-step.applications-in-this-step',
  'Company/JobIncomplete' = 'ct-library.errors.company.job-incomplete',
  'Company/AlreadyAdded' = 'ct-library.errors.company.facility-already-added',
  'Company/DefaultMailtextNotDeletable' = 'ct-library.errors.company.cant-delete-template',
  'Company/DefaultEMailSignatureNotDeletable' = 'ct-library.errors.company.cant-delete-default-signature',
  'Company/TFARequired' = 'ct-library.errors.company.tfa-required',
  'Company/JobQuotaExceeded' = 'ct-library.errors.company.job-quota-exceeded',
  'Company/KomboApplicationNotYetEligibleForTransfer' = 'ct-library.errors.company.kombo.application-not-yet-eligible-for-transfer',
  'Company/KomboApplicationTransferFailed' = 'ct-library.errors.company.kombo.application-transfer-failed',
  'Company/KomboApplicationTransferAlreadyQueued' = 'ct-library.errors.company.kombo.application-transfer-already-queued',
  'Company/KomboApplicationAlreadyTransferred' = 'ct-library.errors.company.kombo.application-already-transferred',
  'Company/KomboJobClosed' = 'ct-library.errors.company.kombo.job-closed',
  'Company/KomboDuplicateApplication' = 'ct-library.errors.company.kombo.duplicate-application',
  'Company/KomboIntegrationUnavailable' = 'ct-library.errors.company.kombo.integration-unavailable',
  'Company/KomboTemporarilyUnavailable' = 'ct-library.errors.company.kombo.temporarily-unavailable',
  'Company/AddressInUse' = 'ct-library.errors.company.address-in-use',
  'Company/LinkedInUrlInvalid' = 'ct-library.errors.company.linkedin-url-invalid',
  'Company/ScheduledPlanChangeBlocksCancel' = 'ct-library.errors.company.scheduled-plan-change-blocks-cancel',
  'Company/ScheduledPlanChangeBlocksDowngrade' = 'ct-library.errors.company.scheduled-plan-change-blocks-downgrade',

  'Payment/ProviderError' = 'ct-library.errors.payment.provider-error',
}
